import { styled } from "@mui/material/styles";
import MuiStack from "@mui/material/Stack";

const StackRow = styled(MuiStack)(({ theme }) => theme.unstable_sx({
  alignItems: 'center'
}))

export default StackRow
